import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, inject } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs/internal/Observable';
const apiToken = new InjectionToken('API_CONTEXT');

@Injectable({
  providedIn: 'root',
})
export class BaseApiService {
  public readonly http = inject(HttpClient);

  constructor(@Inject(apiToken) public apiContextToken: string) {}

  public buildUrl(path = '', params = {}): string {
    const getQueryString = (params: { [key: string]: string | string[] }) => {
      return Object.keys(params).map((key) => {
        const value = params[key];
        return `${key}=${value}`;
      });
    };

    const queryString = getQueryString(params);

    const newPath =
      queryString.length > 1
        ? `${path}?${queryString.join('&')}`
        : `${path}?${queryString}`;

    const makeQuery =
      path.length > 0
        ? `${environment.BASE_API_URL}/${this.apiContextToken}/${newPath}`
        : `${environment.BASE_API_URL}/${this.apiContextToken}${newPath}`;

    return makeQuery;
  }

  public get<T>(
    path?: string,
    params = {},
    columns?: string[]
  ): Observable<T> {

    return this.http.get<T>(this.buildUrl(path, params), {
      headers: new HttpHeaders().append('columns', columns ?? []),
    });
  }

  public post<T>(body: unknown, path?: string, headers?: {}): Observable<T> {
    return this.http.post<T>(this.buildUrl(path), body, headers);
  }

  public put<T>(body: unknown, path?: string, headers?: {}): Observable<T> {
    return this.http.put<T>(this.buildUrl(path), body, headers);
  }

  public delete<T>(path?: string, headers?: {}): Observable<T> {
    return this.http.delete<T>(this.buildUrl(path), headers);
  }
}
